import React, { Component } from 'react';
import { Link } from 'react-router-dom';
export default class userdropdown extends Component {
  logout() {
    localStorage.setItem('userId', "");
    localStorage.setItem('displayName', "");
    localStorage.setItem('role', "");
    window.sessionStorage.setItem('mobileNumber', "");
    window.sessionStorage.setItem('emailId', "");
    window.sessionStorage.setItem('addressId', "");
    window.location.href = "/";
  }
  render() {
    let displayName = localStorage.getItem('displayName');
    return (
      <div className="userdropdown" id="userdropdown" style={{ display: 'none' }}>
        <div className="userNameTitle">Hi {displayName}</div>
        {localStorage.getItem('role') === 'ROLE_ADMIN' ?
          <div className="userDropLink">
            <Link to="/generalAdmin">Dashboard</Link>
          </div>
          :
          (localStorage.getItem('role') === 'ROLE_MAPPING_ADMIN') ?
            <div className="userDropLink">
              <Link to="/sellerManagement">Dashboard</Link>
            </div>
            : (localStorage.getItem('role') === 'ROLE_STORE' || localStorage.getItem('role') === 'ROLE_SELLER') ?
              <div className="userDropLink">
                <Link to="/orderManagement">Dashboard</Link>
              </div>
              :
              <div className="userDropLink">
                <Link to="/dashboard/accountdetails">My Account</Link>
                <Link to="/dashboard/myorders">My Orders</Link>
                {/* <Link to="">Refer Friend</Link> */}
              </div>
        }
        <div className="userDropButton">
          <Link to="/" onClick={this.logout} className="logoutButton">Logout</Link>
        </div>
      </div>
    )
  }
}
